export const CONSUMABLE_BRAND_OPTIONS = ['代购下单'] as const;

export const getConsumableBrandOptions = (currentValue?: string): string[] => {
  const existingValue = String(currentValue || '').trim();
  if (
    !existingValue ||
    CONSUMABLE_BRAND_OPTIONS.includes(existingValue as typeof CONSUMABLE_BRAND_OPTIONS[number])
  ) {
    return [...CONSUMABLE_BRAND_OPTIONS];
  }
  return [existingValue, ...CONSUMABLE_BRAND_OPTIONS];
};
